import ButtonGroupCustom from "components/ButtonGroupCustom/ButtonGroupCustom";
import React from "react";
import { UseAppDispatch } from "redux/store";
import { useSelector } from "react-redux";
import { Box, Typography } from "@mui/material";
import {
  searchFormSelector,
  ICabinClass,
  changeCabinClass,
} from "redux/searchForm";
import { useTranslations } from "hooks/useTranslations";
import { ICabinType } from "@thekilroygroup/shared-ui";

export default function CabinClasses() {
  const { cabinClass } = useSelector(searchFormSelector);
  const dispatch = UseAppDispatch();
  const handleChange = (option: ICabinClass) => {
    dispatch(changeCabinClass(option.id as ICabinType));
  };
  const { translations } = useTranslations();
  const translationsCabinClasses = translations.search.who.cabinClasses;

  const selectedCabinClass = translationsCabinClasses.values.find(
    ({ id }) => id === cabinClass,
  );

  return (
    <Box
      sx={{
        width: { md: 0.5 },
        pl: { md: 2 },
      }}
    >
      <Typography variant="h5" color={"primary.main"}>
        {translationsCabinClasses.title}
      </Typography>
      <Box sx={{ pt: 3 }}>
        <ButtonGroupCustom
          selected={
            selectedCabinClass !== undefined ? [selectedCabinClass] : null
          }
          options={translationsCabinClasses.values}
          onChange={(option) => handleChange(option)}
          align="top-left"
        />
      </Box>
    </Box>
  );
}
